var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrmGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71403 7.19873C2.47642 7.19922 2.24865 7.2937 2.08047 7.46156C1.91229 7.62941 1.81736 7.85699 1.81641 8.0946V15.2932C1.81641 16.7727 3.03331 17.9878 4.51281 17.9878H13.5084C14.9879 17.9878 16.2048 16.7727 16.2048 15.2932V8.0946C16.2039 7.85699 16.1089 7.62941 15.9407 7.46156C15.7726 7.2937 15.5448 7.19922 15.3072 7.19873H2.71403Z",
    fill: "#82BBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41603 0.00195312C3.96992 0.00195312 2.65193 0.848664 2.05563 2.1661L1.25988 3.92622C0.50069 4.58172 0.00390625 5.54919 0.00390625 6.63491C0.00390625 8.61116 1.62701 10.2342 3.6032 10.2342C4.74603 10.2342 5.64433 9.61924 6.30487 8.77974C6.96541 9.61942 7.87059 10.2342 9.01357 10.2342C10.1511 10.2342 11.0491 9.62488 11.71 8.79203C12.3708 9.62506 13.2669 10.2342 14.4046 10.2342C16.3808 10.2342 18.0039 8.61116 18.0039 6.63491C18.0039 5.5751 17.5205 4.64276 16.7936 3.98946L15.9048 2.0203C15.3486 0.791622 14.1214 0.00195312 12.7727 0.00195312H5.41603Z",
    fill: "#007FF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01417 11.6943C7.53467 11.6943 6.3125 12.9095 6.3125 14.389V17.0924C6.31345 17.3309 6.40911 17.5593 6.57843 17.7273C6.74775 17.8953 6.97687 17.9892 7.2154 17.9883H10.8147C11.052 17.9873 11.2793 17.8926 11.4471 17.7248C11.6149 17.557 11.7096 17.3297 11.7106 17.0924V14.389C11.7106 12.9095 10.4937 11.6943 9.01417 11.6943Z",
    fill: "#007FF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmGroup);
export default __webpack_public_path__ + "static/media/crm-group.2dbdaf302fe810f344388912cf9dc3e3.svg";
export { ForwardRef as ReactComponent };